// Calculs Triple Fusion™ côté client — Chemin de Vie (Pythagore) + Kua (numérologie Lo Shu).

const reduceToDigit = (n) => {
  let v = Math.abs(n);
  while (v > 9) v = String(v).split("").reduce((s, d) => s + Number(d), 0);
  return v;
};

// birth: { day, month, year } (nombres) — somme de TOUS les chiffres, réduite à 1-9.
export function cheminDeVie({ day, month, year }) {
  const digits = `${String(day).padStart(2, "0")}${String(month).padStart(2, "0")}${year}`;
  return reduceToDigit(digits.split("").reduce((s, d) => s + Number(d), 0));
}

// gender: "homme" | "femme". Formule exacte fournie — règle du 5 : H→2, F→8.
export function kua(year, gender) {
  const isMale = gender === "homme";
  const base = reduceToDigit(Math.floor((year % 100) / 10) + (year % 10));
  let k = year < 2000 ? (isMale ? 10 - base : 5 + base) : (isMale ? 9 - base : 6 + base);
  k = reduceToDigit(k);
  if (k === 5) k = isMale ? 2 : 8;
  return k;
}

// "JJ/MM/AAAA" ou "AAAA-MM-JJ" → {day, month, year} | null
export function parseBirthdate(str) {
  const s = (str || "").trim();
  let m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (m) return { day: +m[1], month: +m[2], year: +m[3] };
  m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return { day: +m[3], month: +m[2], year: +m[1] };
  return null;
}

export function isValidBirthdate(b) {
  if (!b) return false;
  const d = new Date(Date.UTC(b.year, b.month - 1, b.day));
  return d.getUTCFullYear() === b.year && d.getUTCMonth() === b.month - 1 && d.getUTCDate() === b.day
    && b.year >= 1900 && d.getTime() <= Date.now();
}
